import React, { useState } from 'react';
import { Carousel } from 'primereact/carousel';
import OrganizationCard from './OrganizationCard';

type Organization = {
    id: string;
    name: string;
    location: string;
    type: string;
    rating: number;
    venues: number;
    staff: number;
    status: string;
};

type OrganizationOverviewProps = {
    organizations: Organization[];
};

const OrganizationOverview: React.FC<OrganizationOverviewProps> = ({ organizations }) => {
    const [activeFilter, setActiveFilter] = useState<string>('all');

    const filters = [
        { key: 'all', label: 'All', count: organizations.length },
        { key: 'active', label: 'Active', count: organizations.filter((org) => org.status === 'active').length },
        { key: 'expiring', label: 'Expiring', count: organizations.filter((org) => org.status === 'expiring').length },
        { key: 'underperforming', label: 'Underperforming', count: organizations.filter((org) => org.status === 'underperforming').length },
    ];

    const filteredOrganizations = activeFilter === 'all' ? organizations : organizations.filter((org) => org.status === activeFilter);

    const responsiveOptions = [
        {
            breakpoint: '1400px',
            numVisible: 4,
            numScroll: 1,
        },
        {
            breakpoint: '1200px',
            numVisible: 3,
            numScroll: 1,
        },
        {
            breakpoint: '992px',
            numVisible: 2,
            numScroll: 1,
        },
        {
            breakpoint: '768px',
            numVisible: 1,
            numScroll: 1,
        },
    ];

    const itemTemplate = (org: Organization) => {
        return (
            <div className="org-card-wrapper">
                <OrganizationCard
                    name={org.name}
                    location={org.location}
                    status={org.status as any}
                    isPremium={org.type === 'Premium'}
                    isStandard={org.type === 'Standard'}
                    averageRating={org.rating}
                    venueCount={org.venues}
                    staffCount={org.staff}
                />
            </div>
        );
    };

    return (
        <div className="organization-overview dashboard-card-wrapper coming-soon-card">
            <div className="overview-header">
                <h2 className="overview-title">Organization Overview</h2>
                <div className="overview-filters">
                    {filters.map((filter) => (
                        <button
                            key={filter.key}
                            className={`filter-btn ${activeFilter === filter.key ? 'active' : ''}`}
                            onClick={() => setActiveFilter(filter.key)}
                        >
                            {filter.label}
                            <span className="filter-count">{filter.count}</span>
                        </button>
                    ))}
                </div>
            </div>

            <div className="organizations-carousel">
                <Carousel
                    value={filteredOrganizations}
                    numVisible={4}
                    numScroll={1}
                    responsiveOptions={responsiveOptions}
                    itemTemplate={itemTemplate}
                    showNavigators
                    showIndicators={false}
                />
            </div>
        </div>
    );
};

export default OrganizationOverview;
